export type DocumentKind = 'pdf' | 'image' | 'other'

const NON_PREVIEWABLE_EXTENSIONS = [
  'csv',
  'doc',
  'docx',
  'odp',
  'ods',
  'odt',
  'ppt',
  'pptx',
  'rtf',
  'txt',
  'xls',
  'xlsx',
]

// drops the query/hash and the scheme + host, so a bare domain has no extension
const getPathname = (url: string) => {
  const path = url.split(/[?#]/)[0]
  const schemeEnd = path.indexOf('://')

  return schemeEnd === -1
    ? path
    : path.slice(schemeEnd + 3).replace(/^[^/]*/, '')
}

const getFileExtension = (url: string) =>
  getPathname(url).split('/').pop()?.split('.').slice(1).pop()?.toLowerCase() ??
  ''

export const isPdfDocument = (url: string) => url.toLowerCase().includes('.pdf')

export const getDocumentName = (url: string) =>
  getPathname(url).split('/').pop() || url

// Only known document types get the placeholder; anything else stays on the
// image path, as it always has
export const getDocumentKind = (url: string): DocumentKind => {
  if (isPdfDocument(url)) return 'pdf'

  return NON_PREVIEWABLE_EXTENSIONS.includes(getFileExtension(url))
    ? 'other'
    : 'image'
}
